/** Soft visual cap for long first names (emails used as names, etc.). */
const DISPLAY_NAME_MAX = 16;

export function displayFirstName(name, maxChars = DISPLAY_NAME_MAX) {
  const text = String(name ?? "").trim();
  if (!text) return "";
  if (text.length <= maxChars) return text;
  return `${text.slice(0, Math.max(1, maxChars - 1))}…`;
}
